import { render, staticRenderFns } from "./vertaapankkeja.vue?vue&type=template&id=433245aa&"
import script from "./vertaapankkeja.vue?vue&type=script&lang=js&"
export * from "./vertaapankkeja.vue?vue&type=script&lang=js&"
import style0 from "./vertaapankkeja.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports